/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * REGULAR — every dish in every subgroup ships in the offer (the classic behaviour). PACKAGE — the offer has a manual per-person price; subgroups may cap how many dishes the customer picks from a pool (see `maxDistinctDishes`), and only `selected` dishes form the final offer. Configured on predefined-offer templates only. 
 */

export const OfferTypeDto = {
    Regular: 'REGULAR',
    Package: 'PACKAGE',
} as const;

export type OfferTypeDto = typeof OfferTypeDto[keyof typeof OfferTypeDto];



